import React from 'react'
import PropTypes from 'prop-types'
import {FormattedNumber, useIntl} from 'react-intl'
import {Box, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {pxToRem} from '../../../utills/pxToRem'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
const ShippingMethodAvailableOptions = ({
    avlOptions,
    selectedMethodDisplayPrice,
    shippingItemPrice
}) => {
    const {currency} = useCurrency()
    const {formatMessage} = useIntl()

    const basePrice = shippingItemPrice ?? avlOptions?.price ?? 0

    const displayPrice =
        selectedMethodDisplayPrice ?? avlOptions?.priceAfterItemDiscount ?? basePrice

    const isDiscounted = displayPrice !== basePrice
    const isFree = displayPrice === 0

    return (
        <Box>
            <Flex gap={pxToRem(8)} alignItems="center">
                <Text
                    margin={0}
                    fontSize={{base: pxToRem(14), lg: pxToRem(16)}}
                    lineHeight="normal"
                    letterSpacing={pxToRem(1)}
                    fontWeight={400}
                    color="black"
                >
                    {avlOptions.name}
                </Text>

                {isDiscounted ? (
                    <Flex gap={pxToRem(6)} alignItems="center">
                        <Text
                            margin={0}
                            fontSize={{base: pxToRem(14), lg: pxToRem(16)}}
                            fontWeight={400}
                            color="black"
                            textDecoration="line-through"
                        >
                            <FormattedNumber
                                value={basePrice}
                                style="currency"
                                currency={currency}
                            />
                        </Text>
                        <Text
                            margin={0}
                            fontSize={{base: pxToRem(14), lg: pxToRem(16)}}
                            fontWeight={600}
                            color={isFree ? 'cav_carmine_red' : 'cav_black'}
                        >
                            {isFree ? (
                                formatMessage({defaultMessage: 'FREE'})
                            ) : (
                                <FormattedNumber
                                    value={displayPrice}
                                    style="currency"
                                    currency={currency}
                                />
                            )}
                        </Text>
                    </Flex>
                ) : (
                    <Text margin={0} fontSize={{base: pxToRem(14), lg: pxToRem(16)}} color="black">
                        <FormattedNumber value={basePrice} style="currency" currency={currency} />
                    </Text>
                )}
            </Flex>
            <Text
                margin={0}
                fontSize={{base: pxToRem(12), lg: pxToRem(13)}}
                fontWeight={400}
                color="cav_pdp_dark_gray"
            >
                {avlOptions.description}
            </Text>
        </Box>
    )
}
ShippingMethodAvailableOptions.propTypes = {
    avlOptions: PropTypes.object,
    selectedMethodDisplayPrice: PropTypes.number,
    shippingItemPrice: PropTypes.number
}
export default ShippingMethodAvailableOptions
